import AbstractRestApi from '@/api/RestApi/AbstractRestApi'

class PromotionsApiClient extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/promotions'
    }
}

export default new PromotionsApiClient()
